export enum SignalTypeEnum {
  MA = 'MA',
  JV_PARTNERSHIP = 'JV_PARTNERSHIP'
}